<script setup>
import { onUpdated, defineProps, ref } from "vue"
import { KNOLIA } from "@/knolia"
import { Gems } from "@/gems"
import RatingScale from "../RatingScale.vue"
import ValidationTypeModal from "../ValidationTypeModal.vue"

const props = defineProps({
  ratingData: {
    type: Object,
    default: Object
  },

  ratingSkillsModal: {
    type: Object,
    default: Object
  }
})

const selectedElement = ref([])
const showValidationTypeModal = ref(false)

onUpdated(() => {
  for (let skill in props.ratingData.rankList) {

    const sitemap = document.getElementById(`skill${skill}`)
    if(sitemap)
      Gems.Tooltip(sitemap, props.ratingData.rankList[skill].sitemap, "tooltip tooltip-left")
  }
});

</script>

<template>
  <div class="rank-table">
    <div class="rank-grid-header">
      <span class="desig">Descrição</span>
      <span>Nível (consigo fazer/conheço)</span>
      <span class="validateHeader"></span>
      <span class="line-clamp line-clamp-1">Validação</span>
      <span>Estado</span>
    </div>

    <div>
      <div v-for="(element, index) in props.ratingData.rankList.value" :key="element" class="rank-grid" :class="{'bg-alt-line': index % 2 == 0, 'highlighted': element.highlight}">

        <div class="td-desig">
          <div class="div-highlight-row" @mouseenter="Gems.Tooltip($event.target, 'Destacar', 'tooltip')">
            <i class="fa-solid fa-highlighter" @click="props.ratingData.ChangeHighlight(element)"></i>
          </div>

          <i v-if="!element.is_op_skill" class="fa-solid fa-copyright" @mouseover="props.ratingData.ManageTooltip($event.target, element)"></i>
          <span :id="`skill${index}`" class="line-clamp line-clamp-1" @mouseover="Gems.Tooltip($event.target, element.sitemap, 'tooltip tooltip-left')"> {{ element.designation }} </span>
        </div>
  
        <span class="radios">
          <RatingScale :rating-data="props.ratingData" :element="element" :mobile-view="false"/>
        </span>

        <span class="modal-icon">
          <i class="fa-eye fas cursor-pointer" @click="props.ratingSkillsModal.OpenModalDocs(element)" @mouseenter="Gems.Tooltip($event.target, 'Anexar e Comentários', 'tooltip')"></i>
          <i class="fas fa-envelope" v-if="element.has_unread_messages" @mouseenter="Gems.Tooltip($event.target, 'Tens novas mensagens', 'tooltip')"></i>
        </span>
                
        <span :id="`validation${index}`" :class="KNOLIA.ToBoolean(element.waiting_validation) ? 'temporary' : ''" class="line-clamp line-clamp-1" 
            @mouseenter="Gems.Tooltip($event.target, props.ratingData.validationTooltipText(element), 'tooltip')"
            v-if="element.rating || !element.rating && element.current_validation != 1">
            <span v-if="element.waiting_validation">Declarado</span>
            <span v-else>{{ element.current_validation_designation }} {{ props.ratingData.GetLastRatingTxt(element) }}</span>
        </span>
    
        <span class="btn-validate">
          <div v-if="element.rating != null">
            <button class="ddl-alt-padding" v-if="!KNOLIA.ToBoolean(element.waiting_validation) && (element.current_validation != 4 || element.rating != element.current_rating)" 
              @click="selectedElement = element; showValidationTypeModal = true">SOLICITAR VALIDAÇÃO</button>
            <span class="waiting-validation line-clamp line-clamp-1" v-else-if="KNOLIA.ToBoolean(element.waiting_validation)" @mouseenter="Gems.TooltipIfNeeded($event.target)">VALIDAÇÃO EM PROGRESSO</span>
          </div>
        </span>
      </div>
    </div>
  </div>

  <ValidationTypeModal :rating-data="props.ratingData" :show-validation-type-modal="showValidationTypeModal" :element="selectedElement" @close-modal="showValidationTypeModal = false"/>
</template>

<style scoped>
@import '../assets/styles/rating-skills.css';

.search-elem {
  width: 40%;
}

.depth-ddl select {
  height: 100%;
  width: 140px;
  border: 1px solid grey;
}

.rank-table {
  margin: 0 auto;
  width: 100%;
  text-align: center;
}

.rank-grid-header {
  font-weight: bold;
}

.rank-grid {
  border-left: 4px solid transparent;
}

.highlighted {
  border-left-color: var(--knolia-yellow-white);
  color: var(--knolia-yellow-white);
}

.div-highlight-row {
  opacity: 0;
  width: 0px;
}

.rank-grid:hover {
  transition: .2s linear;
  border-left-color: transparent;
}

.rank-grid:hover .div-highlight-row {
  display: block;
  transition: .2s linear;
  opacity: 1;
  width: 15px;
  cursor: pointer;
}

.rank-grid,
.rank-grid-header {
  display: grid;
  grid-template-columns: 38% 25% 5% 13% 15%;
  text-align: center;
  align-items: center;
  gap: 1%;
  padding: 0px 6px;
  margin-bottom: 2px;
}

.radios {
  display: flex;
  font-size: 1.2em;
  justify-content: center;
}

.rank-table tbody td button {
  height: 28px;
  line-height: 1px;
}

.td-desig {
  cursor: default;
  gap: 5px;
  display: flex;
  align-items: center;
}

.td-desig i {
  margin-top: -1px;
}

.modal-icon {
  font-size: 1.3em;
}

.fa-envelope { 
  position: relative;
  left: 0px;
  top: -9px;
  font-size: 0.7em !important;
  width: 0px;
}

.temporary {
  font-weight: 600;
  cursor: default;
}

.disabled {
  border-color: transparent;
  cursor: default;
}

.disabled:hover {
  border-color: transparent;
  background-color: transparent;
  color: inherit;
}

.btn-validate button {
  width: fit-content;
}

.waiting-validation {
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85em !important;
}

@media only screen and (max-width: 1300px) {

  .search-elem {
    width: 25%;
  }

}

@media screen and (max-width: 990px) {
  .rank-grid {
    grid-template-columns: 31% 34% 3% 13% 15%;
  }

  .rank-grid-header {
    grid-template-columns: 31% 34% 3% 13% 15%;
  }

  .td-desig i {
    margin-top: 0px;
  }

  .radios {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    row-gap: 3px;
  }

  .radios input {
    transform: scale(1) !important;
    margin-top: 0px;
  }

  .radios div {
    padding: 1px;
  }

  .fa-copyright {
    font-size: 1.2em;
  }

}
</style>
